<template>
  <div :class="classList">
    <input
      :id="id"
      type="checkbox"
      name="map-filter[]"
      :value="termId"
      :checked="checkedList.indexOf(termId) > -1"
      @click="setList"
    />
    <label class="marker" :for="identifier">{{ name }}</label>
  </div>
</template>

<script>
export default {
  name: 'FilterOption',

  props: {
    name: {
      type: String,
      default: '',
    },
    internalName: {
      type: String,
      default: '',
    },
    termId: {
      type: Number,
      default: 0,
    },
    checkedList: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  computed: {
    id() {
      return `checkbox-${this.internalName}`;
    },

    identifier() {
      return `checkbox-${this.internalName}`;
    },

    classList() {
      return `cb ${this.internalName}`;
    },
  },
  methods: {
    setList() {
      this.$emit('updateKey', this.termId);
    },
  },
};
</script>
